import { render, staticRenderFns } from "./my_modify_psd.vue?vue&type=template&id=2b30c4a2&scoped=true"
import script from "./my_modify_psd.vue?vue&type=script&lang=js"
export * from "./my_modify_psd.vue?vue&type=script&lang=js"
import style0 from "./my_modify_psd.vue?vue&type=style&index=0&id=2b30c4a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b30c4a2",
  null
  
)

export default component.exports